module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921131149_T.bf94b052.jpg";